import React, { Component } from "react";
import axios from "axios";
import LoadingScreen from "../../components/LoadingScreen";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import SweetAlert from "react-bootstrap-sweetalert";
// import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserCircle,
  faUserCog,
  faCog,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";
import Container from "../../components/Container";

class ViewBrief extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: [],
      brief: [],
      isReady: 0,
      alert: null,
      messages: null,
    };
    this.confirmLogout = this.confirmLogout.bind(this);
    this.getCustomerBrief = this.getCustomerBrief.bind(this);
  }

  componentDidMount() {
    axios
      .get(`${window.localhost}/customer/whois`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        var msg = response.data.success;
        if (msg === true) {
          this.getCustomerBrief();
          var progress = this.state.isReady + 50;
          this.setState({
            user: response.data.user,
            isReady: progress,
          });
        } else {
          this.props.history.push("/login");
        }
      });
  }

  getCustomerBrief() {
    const { btype, id } = this.props.match.params;
    axios
      .get(`${window.localhost}/customer/brief/view/${btype}/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        var msg = response.data.success;
        if (msg === true) {
          var progress = this.state.isReady + 50;
          this.setState({
            brief: response.data.brief,
            isReady: progress,
          });
          // console.log(response.data.brief);
        } else {
          this.props.history.push("/");
        }
      });
  }

  confirmLogout() {
    const getAlert = () => (
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Logout"
        cancelBtnText="Batal"
        confirmBtnBsStyle="default"
        cancelBtnBsStyle="danger"
        title="Tunggu..."
        onConfirm={() => this.handleLogout()}
        onCancel={() => this.hideAlert()}
        focusCancelBtn
      >
        Apakah Anda yakin ingin Logout?
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  handleLogout() {
    axios
      .get(`${window.localhost}/customer/logout`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        var msg = response.data.success;
        if (msg === true) {
          this.props.history.push("/login");
        }
      });
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  render() {
    if (this.state.isReady !== 100) {
      return <LoadingScreen />;
    } else {
      const { user, brief } = this.state;
      const navmenu = () => {
        return (
          <div className="dropdown">
            <button
              className="btn text-danger d-flex align-items-center dropdown-toggle"
              aria-current="page"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="me-2 d-md-flex d-none">{user.fullname}</span>
              <FontAwesomeIcon icon={faUserCircle} className="fs-3" />
            </button>
            <ul
              className="dropdown-menu dropdown-menu-end"
              aria-labelledby="dropdownMenuButton1"
            >
              <li>
                <a className="dropdown-item" href="/info-pengguna">
                  <FontAwesomeIcon icon={faUserCog} /> Info Pengguna
                </a>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <button className="dropdown-item" onClick={this.confirmLogout}>
                  <FontAwesomeIcon icon={faSignOutAlt} /> Logout
                </button>
              </li>
            </ul>
          </div>
        );
      };
      return (
        <div>
          <Header menu={navmenu()} destination={`/`} />
          <Container>
            <div className="row px-0">
              <h1 className="px-0 text-center mb-3">
                <span className="cf-header px-2 fw-bold">
                  {user.institusi}'s Logo Brief
                </span>
              </h1>
              <hr />
            </div>

            <div className="row row-cols-1 g-4">
              {brief.map((brf, index) => (
                <div className="col" key={index}>
                  <div className="card w-100">
                    <div className="row">
                      <div
                        className={
                          brf.question.answer_type === "image"
                            ? "col-md-8 col-12"
                            : "col-12"
                        }
                      >
                        <div className="card-body">
                          <h5 className="card-title text-danger">
                            {brf.question.label}
                          </h5>
                          {brf.question.answer_type === "image" ? (
                            <a
                              className="btn btn-sm btn-yellow"
                              href={`${
                                window.localhost
                              }/brief/${user.institusi.replace(/ /g, "_")}/${
                                brf.answer
                              }`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              Unduh Gambar
                            </a>
                          ) : (
                            <p>
                              <b>Jawab</b>: {brf.answer}
                            </p>
                          )}
                        </div>
                      </div>
                      {brf.question.answer_type === "image" ? (
                        <div className="col-md-4 col-12">
                          <img
                            src={`${
                              window.localhost
                            }/brief/${user.institusi.replace(/ /g, "_")}/${
                              brf.answer
                            }`}
                            alt=""
                            className="img-fluid"
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Container>
          {this.state.alert}

          <Footer />
        </div>
      );
    }
  }
}

export default ViewBrief;
